/* ===== Подключение иконок ===== */
import { ReactComponent as people } from "../../assets/icons/ui/people.svg";
import { ReactComponent as smile } from "../../assets/icons/ui/smile.svg";
import { ReactComponent as box } from "../../assets/icons/ui/box.svg";
import { ReactComponent as avto } from "../../assets/icons/ui/avtomobile.svg";
import { ReactComponent as shild } from "../../assets/icons/ui/shild.svg";
import { ReactComponent as boxs } from "../../assets/icons/ui/boxssss.svg";


const problemCards = {
    id: "problems",
    grid: { cols: { base: 1, sm: 2, lg: 2 }, gap: "var(--spacing-4)" },
    items: [
        {
            id: "problem-1",
            type: "problem",
            Icon: people,
            title: "Завышенные цены у посредников",
            text: "Малые объёмы закупки обычно сопровождаются высокими наценками. В результате ваш бизнес переплачивает за топливо.",
        },
         {
            id: "problem-2",
            type: "problem",
            Icon: boxs,
            title: "Честные цены",
            text: `
                    Компания работает напрямую с крупнейшими
                    нефтебазами и НПЗ
                    без посредников и лишних наценок.
                    Это гарантирует честную цену для клиента.
                  `,
        },
        {
            id: "problem-3",
            type: "problem",
            Icon: smile,
            title: "Слабый сервис и поддержка",
            text: "Сложно дозвониться, нет сопровождения и ответственности. Вопросы решаются медленно.",
        },
        {
            id: "problem-4",
            type: "problem",
            Icon: avto,
            title: "Гибкие объёмы и быстрая доставка",
            text: `От 500л и до 30 000л. Доставка по Москве и области занимает от 24 часов с момента заказа.`,
        },
        {
            id: "problem-5",
            type: "problem",
            Icon: box,
            title: "Непрозрачное качество",
            text: "Нет документов, непонятное происхождение топлива и риски по качеству.",
        },
        {
            id: "problem-6",
            type: "problem",
            Icon: shild,
            title: "Гарантированное качество Евро-5",
            text: `Поставляется только сертифицированное
                   дизельное топливо Евро-5 – к каждой партии
                   прилагается паспорт качества. Клиент
                   уверенно получает топливо, соответствующее
                   ГОСТ и безопасное для техники.
                  `,
        },
    ],
};

export default problemCards;
